import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import TextField from "../inputs/TextField";
import { Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as Yup from "yup";
import { Formik } from "formik";
import Dropzone from "../inputs/Dropzone";
import { Link } from "../buttons";
const useStyles = makeStyles(() => ({
  styledTextfield: {
    "& .MuiInputBase-root": {
      borderRadius: "12px",
    },
  },
  styledAnchor: {
    borderBottom: "1px solid #B1D238",
  },
  anchorTag: {
    fontWeight: 500,
    borderBottom: "1px solid black",
    color: "black",
  },
}));
export interface SignupProfessionalFormInteface {
  handleAction: (type: any, data?: any) => void;
  initialData: {
    firstName: string;
    lastName: string;
    password: string;
    confirmPassword: string;
    imageURL: string;
  };
  schema: any;
}
const SignupProfessionalForm = ({
  handleAction,
  initialData,
  schema,
}: SignupProfessionalFormInteface) => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <Stack justifyContent="center" alignItems="center" spacing={5}>
      <Stack alignItems="center" spacing={3}>
        <Typography variant="h1" fontWeight={700} textAlign="center">
          Welcome to your Professional Event Network!
        </Typography>
        <Typography variant="h4" fontWeight={500} textAlign="center">
          Find out “What’s Going On” in the financial services industry right at
          your fingertips - Getting started is easy!
        </Typography>
      </Stack>
      <Formik
        initialValues={initialData}
        validationSchema={Yup.object().shape(schema)}
        onSubmit={(values) => handleAction("submit", values)}
        render={({
          handleChange,
          handleBlur,
          values,
          touched,
          setFieldValue,
          errors,
          handleSubmit,
        }: any) => (
          <form
            onSubmit={handleSubmit}
            style={{ height: "100%", width: "100%" }}
          >
            <Stack spacing={1.5}>
              <Stack alignItems="center">
                <Dropzone
                  image={values.imageURL}
                  rounded
                  handleDrop={(file) => {
                    setFieldValue("imageURL", URL.createObjectURL(file[0]));
                  }}
                />
              </Stack>
              <Stack
                display="flex"
                flexDirection="row"
                alignItems="baseline"
                justifyContent="space-between"
                mt={2}
                width="100%"
              >
                <TextField
                  label="First Name"
                  name="firstName"
                  id="firstName"
                  placeholder="First Name"
                  helperText={touched.firstName ? errors.firstName : ""}
                  error={touched.firstName && Boolean(errors.firstName)}
                  value={values.firstName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <Stack width="5%" />

                <TextField
                  label="Last Name"
                  name="lastName"
                  id="lastName"
                  placeholder="Last Name"
                  helperText={touched.lastName ? errors.lastName : ""}
                  error={touched.lastName && Boolean(errors.lastName)}
                  value={values.lastName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Stack>

              <Stack spacing={0.5}>
                <TextField
                  label="Password"
                  name="password"
                  id="password"
                  placeholder="*********"
                  helperText={touched.password ? errors.password : ""}
                  error={touched.password && Boolean(errors.password)}
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type={showPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? (
                            <i className="far fa-eye font-black"></i>
                          ) : (
                            <i className="far fa-eye-slash font-black"></i>
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Typography>
                  8 or more characters, with 1 symbol and 1 number
                </Typography>
              </Stack>
              <Stack spacing={0.5}>
                <TextField
                  label="Confirm Password"
                  name="confirmPassword"
                  id="confirmPassword"
                  placeholder="*********"
                  helperText={
                    touched.confirmPassword ? errors.confirmPassword : ""
                  }
                  error={
                    touched.confirmPassword && Boolean(errors.confirmPassword)
                  }
                  value={values.confirmPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type={showConfirmPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle confirmPassword visibility"
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                          edge="end"
                          sx={{ background: "none!important" }}
                        >
                          {showConfirmPassword ? (
                            <i className="far fa-eye font-black"></i>
                          ) : (
                            <i className="far fa-eye-slash font-black"></i>
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack>
              <Stack spacing={0.5} position="relative" mt={1.5}>
                <Typography>
                  By signing up, you agree to{" "}
                  <a href="/#" target="_blank" className={classes.styledAnchor}>
                    Terms of Service
                  </a>
                  ,{" "}
                  <a href="/#" target="_blank" className={classes.styledAnchor}>
                    Privacy Policy
                  </a>
                  , and{" "}
                  <a href="/#" target="_blank" className={classes.styledAnchor}>
                    Cookie Policy
                  </a>
                  .
                </Typography>
              </Stack>
              <Box mt={2}>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  fullWidth
                  onClick={() => handleSubmit()}
                >
                  Agree & Sign Up
                </Button>
              </Box>
              <Box mt={2} textAlign="center">
                <Typography
                  fontSize={(theme: any) => theme.typography.h5.fontSize}
                >
                  Already have an account?
                  <Link
                    ml="5px"
                    onClick={() => handleAction("login")}
                    label="Login"
                  />
                </Typography>
              </Box>
              <Box mt={2} textAlign="center">
                <Typography
                  fontSize={(theme: any) => theme.typography.h5.fontSize}
                >
                  Need help?
                  <Link
                    ml="5px"
                    onClick={() => handleAction("contact-support")}
                    label="Contact support"
                  />
                </Typography>
              </Box>
            </Stack>
          </form>
        )}
      />
    </Stack>
  );
};
export default SignupProfessionalForm;
